import { ViewChild, ViewEncapsulation } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Store } from '@ngrx/store';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { Product } from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';
import { SalesProductPrice } from '../uig-product.models';
import { getProductPrice, updateProductPrice } from './store/uig-product-price-calculator.actions';
import { UpdateProductPriceState } from './store/uig-product-price-calculator.reducer';
import { selectUpdateProductPrice } from './store/uig-product-price-calculator.selectors';

@Component({
    selector: 'app-uig-product-price-calculator',
    templateUrl: './uig-product-price-calculator.component.html',
    styleUrls: ['./uig-product-price-calculator.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigProductPriceCalculatorComponent implements OnInit {

  salesProductPrice$: Observable<SalesProductPrice>  =
  this.store.select(selectUpdateProductPrice);
  salesProductPrice: SalesProductPrice;

  @ViewChild('priceForm') priceForm: NgForm;
  product$: Observable<Product>;
  product: Product;
  productCode: string;
  userCustomUvpPrice: string;
  userCustomProfitMarginPercent: string;
  editOwnVkUser: boolean;

  constructor(
    private store: Store<UpdateProductPriceState>,
    private currentProductService: CurrentProductService,
    private messageService: GlobalMessageService,
    private translationService: TranslationService) {
      this.product$ = this.currentProductService.getProduct();
      this.product$.pipe(
        filter((product) => product != null),
        tap((product) => {
          this.product = product;
          this.productCode = product.code;
          this.store.dispatch(getProductPrice({ productCode: this.productCode }));
        })
      )
      .subscribe();
    }

  ngOnInit(): void {
    this.salesProductPrice$
    .pipe(
      filter((salesProductPrice) => salesProductPrice != null),
      tap((salesProductPrice) => {
        this.salesProductPrice = salesProductPrice;
        this.editOwnVkUser = salesProductPrice.isMemberofEditOwnVK;
        if(salesProductPrice.userCustomUvpPrice)
        {
          this.userCustomUvpPrice = salesProductPrice.userCustomUvpPrice.replace(/€/g, '');
        }
        else{
          this.userCustomUvpPrice = salesProductPrice.userCustomUvpPrice;
        }
        this.userCustomProfitMarginPercent = salesProductPrice.userCustomProfitMarginPercent;
      })
    )
    .subscribe();
  }

  onSubmit(): void{
    if(this.priceForm.value.userCustomProfitMarginPercent &&
      !this.validForm(this.priceForm.value.userCustomProfitMarginPercent))
    {
      this.notValidProfitMargin();
    }
    else{

      let bestPrice: string = '';
      if(this.product.bestPrice)
      {
        bestPrice = this.product.bestPrice.value.toString();
      }
      this.store.dispatch(updateProductPrice({
        bestPrice: bestPrice,
        productCode: this.product.code,
        userCustomUvpPrice: this.priceForm.value.userCustomUvpPrice,
        userCustomProfitMarginPercent: this.priceForm.value.userCustomProfitMarginPercent,
        taxm1: this.product.taxm1
      }));
    }
  }

  onChangeInput(fieldIndex: string): void{
    if(fieldIndex == '0')
    {
      this.userCustomProfitMarginPercent = '';
    }
    else{
      this.userCustomUvpPrice = '';
    }
  }


  validForm(profitMargin: string): boolean{
    if(Number(profitMargin.replace(/,/g, '.')) <= 99.994)
    {
      return true;
    }
    return false;
  }

  notValidProfitMargin(){
    this.translationService
    .translate('priceCalculator.profitMarginError')
    .pipe(take(1))
    .subscribe((message) => {
      this.messageService.add(
        message,
        GlobalMessageType.MSG_TYPE_ERROR
      );
    });
  }
}
